"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { createClient } from "@/lib/supabase/client";

export function RemoveDividendButton({ eventId }: { eventId: string }) {
  const router = useRouter();
  const [isPending, setIsPending] = useState(false);

  async function handleClick() {
    setIsPending(true);
    const supabase = createClient();
    const { error } = await supabase.from("dividend_events").delete().eq("id", eventId);
    if (!error) router.refresh();
    setIsPending(false);
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      onClick={handleClick}
      disabled={isPending}
      aria-label="Eintrag entfernen"
      title="Eintrag entfernen"
    >
      <Trash2 className="size-4" />
    </Button>
  );
}
